import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "24px",
  },
  flexItem1: {
    flex: "1 1 730px",
    maxWidth: "100%",
    minWidth: 0,
    [theme.breakpoints.down("sm")]: {
      flexBasis: "100%",
      maxWidth: "100%",
    },
  },
  flexItem2: {
    flex: "1 1 0",
    minWidth: 350,
    [theme.breakpoints.down("sm")]: {
      flexBasis: "100%",
      maxWidth: "100%",
      minWidth: "auto",
    },
  },
}));

export default useStyles;
